import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";


type UiFullLoaderType = {
    isLoading: boolean,
    minimumDuration?: number,
    onDuration?: () => void
}

export const UiFullLoader: React.FC<UiFullLoaderType> = (props) => {
    const {t} = useTranslation();
    const isDurationMode: boolean = (props.minimumDuration !== undefined && props.onDuration != undefined)
    
    const [isWaiting, setIsWaiting] = React.useState<boolean>(isDurationMode)

    useEffect(() => {
        let timeout: NodeJS.Timeout | undefined
        
        if (props.minimumDuration && props.onDuration) {
            timeout = setTimeout(() => {
                setIsWaiting(false)
                props.onDuration!()
            }, props.minimumDuration * 1_000)
        }
        
        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, []);

    return (
        <>
            {(isDurationMode ? props.isLoading || isWaiting : props.isLoading) &&
                <div className="fixed w-screen h-screen top-0 left-0 flex items-center justify-center z-50 bg-deep-blue">
                    <img src="/images/full-loader.gif" alt={t("global.loading")} />
                </div>
            }
            
        </>
    )
}
